module.exports = __webpack_public_path__ + "ee744b44305ce56ff805879edc1d37fa.png";